import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  uploadIcon: {
    '& svg': {
      paddingTop: '11px',
      height: '50px',
      width: '100%',
      color: theme.palette.custom.iconAccent,
      margin: '0px',
    },
    '& svg:hover': {
      opacity: '0.8',
    },
  },
  input: {
    display: 'none',
  },
  logoUrl: {
    height: '45px',
  },
  userTable: {
    '& .MuiTableCell-root': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-paddingNone': {
      color: theme.palette.primary.mainBlue,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: theme.palette.custom.tableRowHover,
      },
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.gray,
      cursor: 'pointer',
    },
  },
  successIcon: {
    color: theme.palette.custom.successIcon,
  },
  roleCells: {
    fontSize: '11px',
  },
  toolbarButton: {
    flexGrow: 1,
  },
  toolbarTable: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      fontSize: '13px',
      width: '350px',
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.lightGray,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '2px',
    },
    '& button': {
      backgroundColor: theme.palette.custom.inputBackground,
      color: theme.palette.secondary.gray,
      fontSize: '13.5px',
      '& svg': {
        color: theme.palette.secondary.gray,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.custom.menuItemText,
    },
  },
  popper: {
    zIndex: 2,
    width: '110px',
    '& ul': {
      paddingBottom: '0px',
    },
  },
  titleOption: {
    borderBottom: `1px solid ${theme.palette.secondary.gray}`,
  },
  roleOption: {
    fontSize: '12px',
  },
  activeOption: {
    fontSize: '13.5px',
  },
  clearOption: {
    fontSize: '13.5px',
    borderTop: `1px solid ${theme.palette.secondary.gray}`,
  },
  noContent: {
    height: '710px',
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  projectName: {
    paddingLeft: '16px',
  },
  reportName: {
    paddingLeft: '16px',
  },
  formWrapper: {
    width: '50vw',
    padding: '56px',
    paddingTop: '10px',
    paddingBottom: '20px',
    '& .MuiFormLabel-root': {
      color: theme.palette.custom.inputLabel,
      margin: '15px auto 8px',
      fontSize: '12px',
    },
    '& input': {
      backgroundColor: theme.palette.custom.inputBackground,
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  dialogWrapper: {
    width: '40vw',
    padding: '56px',
    paddingTop: '10px',
    paddingBottom: '20px',
  },
  dialogText: {
    padding: '30px',
  },
  userInfo: {
    display: 'grid',
    gridTemplateColumns: '45% 45%',
    columnGap: '5%',
    padding: '30px',
    '& .MuiFormLabel-root': {
      color: theme.palette.secondary.darkGray,
    },
    '& .MuiFormControl-root': {
      margin: '10px auto',
    },
    '& input': {
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  itemList: {
    fontSize: '13.5px',
    color: theme.palette.custom.menuItemText,
  },
  role: {
    gridColumn: 1,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gridColumn: 2,
    '& button': {
      width: '47%',
      color: theme.palette.custom.solidButtonText,
      backgroundColor: theme.palette.custom.solidButtonBackground,
    },
    '& button:first-child': {
      color: theme.palette.secondary.gray,
      backgroundColor: theme.palette.custom.outlineButtonBackground,
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
  },
  users: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  tableHeader: {
    color: theme.palette.secondary.gray,
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  title: {
    marginBottom: '5px',
  },
  tag: {
    borderRadius: '5px',
    padding: '6px 9px',
    maxWidth: '120px',
    margin: '0px auto',
  },
  tagIcon: {
    borderRadius: '5px',
    padding: '0px 0px',
    maxWidth: '120px',
    margin: '0px auto',
  },
  tagActive: {
    color: theme.palette.custom.statusOpenText,
    backgroundColor: theme.palette.custom.statusOpenBackground,
  },
  tagInactive: {
    color: theme.palette.custom.statusPendingText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  tagWarning: {
    color: theme.palette.custom.statusWarningText,
    backgroundColor: theme.palette.custom.statusWarningBackground,
  },
  editDeleteButtons: {
    marginRight: '20px',
    '& .MuiIconButton-root': {
      width: '35px',
      '&:hover': {
        backgroundColor: theme.palette.custom.cardBackground,
      },
    },
  },
  tokensColumn: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'left',
  },
  id: {
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
    paddingLeft: '16px',
  },
  tagsInput: {
    '& .ReactTags__tags': {
      width: '100%',
    },
    '& .ReactTags__selected': {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px',
      marginTop: '12px',
      marginBottom: '8px',
    },
    '& .ReactTags__tag': {
      backgroundColor: theme.palette.custom.solidButtonBackground,
      color: theme.palette.custom.solidButtonText,
      borderRadius: '5px',
      padding: '4px 8px',
      fontSize: '13px',
      display: 'inline-flex',
      alignItems: 'center',
    },
    '& .ReactTags__remove': {
      marginLeft: '6px',
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      color: theme.palette.custom.solidButtonText,
      fontSize: '14px',
      lineHeight: 1,
    },
    '& .ReactTags__tagInputField': {
      width: '100%',
      padding: '10px',
      border: `1px solid ${theme.palette.secondary.lightGray}`,
      borderRadius: '3px',
      fontSize: '13.5px',
      boxSizing: 'border-box',
    },
  },
}));

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.secondary.blue,
  },
}))(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: '75px',
    textTransform: 'none',
    padding: '0px 8px',
    margin: '0px 10px',
    color: theme.palette.primary.gray,
  },
}))((props) => <Tab disableRipple {...props} />);

export default useStyles;
